import { render, staticRenderFns } from "./SearchSuggestionsForm.vue?vue&type=template&id=5400beeb&"
import script from "./SearchSuggestionsForm.vue?vue&type=script&lang=js&"
export * from "./SearchSuggestionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports